<template>
  <div>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix" style="border: none">
              <i class="el-icon-card-header"></i>
              <span>贴敷统计</span>
            </div>

            <el-row style="margin-top: 10px;margin-bottom: 20px">
              选择时间：<el-date-picker
                  v-model="date_value"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right">
              </el-date-picker>
            </el-row>
            <!--    <el-row :gutter="20" style="margin-top: 20px; margin-left: 20px">-->
            <!--      <el-col :span="8" v-for="item in tiefu_boards_info" style="margin-top: 10px"-->
            <!--              :key="item.label">-->
            <!--        <el-card>-->
            <!--          <el-row>-->
            <!--            <el-col :span="24" class="numClass">{{ item.num }}<span class="unitClass">{{ item.unit }}</span></el-col>-->
            <!--            <el-col :span="24" class="hintClass">{{ item.label }}</el-col>-->
            <!--          </el-row>-->
            <!--        </el-card>-->
            <!--      </el-col>-->
            <!--    </el-row>-->
            <el-row  :gutter="10">
              <el-col :span="12">
                <LineChart id="tfcf_trend" path="tfcf_trend" height="300px" width="100%" :key="dateKey"
                           :params='{"clinic_id":clinic_id,"date_start":date_value[0],"date_end":date_value[1]}'>

                </LineChart>
              </el-col>
              <el-col :span="12">
                <LineChart id="xzztt_trend" path="xzztt_trend" height="300px"  width="100%" :key="dateKey"
                  :params='{"clinic_id":clinic_id,"date_start":date_value[0],"date_end":date_value[1]}'>
                </LineChart>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>



    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="12">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <i class="el-icon-card-header"></i>
            <span>贴敷处方率</span>
          </div>
          <div style="height: 400px">
            <PieChart id="tfcfl_pie"
                      :params='{"clinic_id":clinic_id,"date_start":date_value[0],"date_end":date_value[1]}'
                      height="400px"
                      width="100%"
                      path="tfcfl_pie"></PieChart>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card" shadow="hover">
          <div slot="header" class="clearfix">
            <i class="el-icon-card-header"></i>
            <span>贴敷诊次分布</span>
          </div>
          <div style="height: 400px">
            <PieChart id="tfzc_pie"
                      :params='{"clinic_id":clinic_id,"date_start":date_value[0],"date_end":date_value[1]}'
                      height="400px"
                      width="100%"
                      path="tfzc_pie"></PieChart>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from "moment-timezone";
import LineChart from "@/views/charts/line";
import PieChart from "@/views/charts/pie";

export default {
  name: "ClinicAcupointStat",
  components: {
    LineChart,
    PieChart,
  },
  computed: {
    // 使用字符串 key，避免非原始类型警告
    dateKey() {
      return Array.isArray(this.date_value) ? this.date_value.join('|') : '';
    }
  },
  data() {
    return {
      date_value: [moment().subtract(30, 'd').startOf('day').format('YYYY-MM-DD HH:mm:ss'), moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')],
      tiefu_boards_info: null,
      clinic_id: this.$route.query.clinic_id ? this.$route.query.clinic_id : (localStorage.getItem('clinic_id') ? localStorage.getItem('clinic_id') : '1650588070122270721'),
      // clinic_id: '1650588070122270721',
      // clinic_id: this.$route.query.clinic_id ? this.$route.query.clinic_id : (localStorage.getItem('clinic_id') ? localStorage.getItem('clinic_id') : '4237'),
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime());
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            start.setHours(0, 0, 0, 0)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '全部',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3650);
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  mounted() {
    this.get_tiefu_boards_info_list();
  },
  methods: {
    get_tiefu_boards_info_list() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/get_tiefu_boards_info_list?clinic_id="
          + this.clinic_id).then((res) => {
        console.log(res);
        this.tiefu_boards_info = res.data.data
      })
    },
  }
}
</script>

<style scoped>
.numClass {
  font-weight: 500;
  font-size: 32px;
  line-height: 45px;
}

.numClass .unitClass {
  font-size: 22px;
}

.hintClass {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
</style>
